'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, useState } from 'react';
import type { PropsWithChildren } from 'react';
import { useCookie } from 'react-use';
import { demoSettingsCookieName, getDemoSettingsCookieExpiration, getDemoSettingsFromCookie, type DemoSettings, type Environment } from './environment';
export const EnvironmentContext = createContext<(Environment & {
  authToken: string;
  updateAuthToken: (token: string) => void;
  demoSettings: DemoSettings;
  updateDemoSettings: (settings: DemoSettings) => void;
}) | null>(null);
export const EnvironmentProvider = t0 => {
  const $ = _c(12);
  const {
    environment,
    authToken,
    children
  } = t0;
  const [token, setToken] = useState(authToken);
  const [demoSettingsCookie, updateDemoSettingsCookie] = useCookie(demoSettingsCookieName);
  let t1;
  if ($[0] !== demoSettingsCookie) {
    t1 = getDemoSettingsFromCookie(demoSettingsCookie);
    $[0] = demoSettingsCookie;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [demoSettings, setDemoSettings] = useState(t1);
  let t2;
  if ($[2] !== updateDemoSettingsCookie) {
    t2 = settings => {
      setDemoSettings(settings);
      updateDemoSettingsCookie(JSON.stringify(settings), {
        expires: getDemoSettingsCookieExpiration()
      });
    };
    $[2] = updateDemoSettingsCookie;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== demoSettings || $[5] !== environment || $[6] !== t2 || $[7] !== token) {
    t3 = {
      ...environment,
      authToken: token,
      updateAuthToken: setToken,
      demoSettings,
      updateDemoSettings: t2
    };
    $[4] = demoSettings;
    $[5] = environment;
    $[6] = t2;
    $[7] = token;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== children || $[10] !== t3) {
    t4 = <EnvironmentContext.Provider value={t3}>{children}</EnvironmentContext.Provider>;
    $[9] = children;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};